import { useEffect } from 'react';

const SilentCallbackPage = () => {
  useEffect(() => {
    console.log('Silent callback processing...');
  }, []);
  return null;
};

export default SilentCallbackPage;
